module.exports = __webpack_public_path__ + "assets/img/page2-design-side-nav-expanded-2-301ad17c.png";